<template>
  <div v-if="devices.length > 0" class="scroll">
    <v-text-field class="mt-2 bg-white" hide-details v-model="devicesSearch" label="Type to begin filtering..." clearable @clear="clearSearch" density="compact" variant="outlined" />
    <v-checkbox v-model="checkAllDevices" @change="checkAll(checkAllDevices)" label="Select All" density="compact" hide-details class="mb-5" />

    <v-row>
      <v-col v-for="(device) in filteredDevices" v-bind="deviceColProps" class="py-0">
        <v-checkbox density="compact" v-model="selectedDevicesData" :value="device['deviceId']" hide-details>
          <template v-slot:label>
            <p v-if="selectedDevicesData.includes(device['deviceId'])" style="font-weight: 600">
              {{ getDeviceName(device['deviceName']) }}
            </p>
            <p v-else class="text-grey-darken-1">
              {{ getDeviceName(device['deviceName']) }}
            </p>
          </template>
        </v-checkbox>
      </v-col>
    </v-row>
  </div>
  <div class="text-center" v-else>No Devices to choose from.</div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import util from '../service/UtilService';

const props = defineProps({
  devices: {
    type: Array,
    required: true
  },
  devicesSearchText: {
    type: String,
    default: ''
  },
  selectAll: {
    type: Boolean,
    default: false
  },
  row: {
    type: Number,
    default: 3
  },
  modelValue: {
    type: Array,
    default: () => []
  },
});
const emit = defineEmits(['update:modelValue']);
const devicesSearch = ref(util.clone(props.devicesSearchText));
const checkAllDevices = ref(props.selectAll);
const selectedDevicesData = ref(props.modelValue);
const valueProps = ref(props.modelValue);

const deviceColProps = computed(() => {
  const cols = props.row === 1 ? 12 : Math.round(12 / props.row);
  return { cols: 12, md: cols };
});

const filteredDevices = computed(() => {
  return props.devices.filter(device => deviceMatch(device));
});

const deviceMatch = (device) => {
  return device.deviceName.toLowerCase().includes(devicesSearch.value?.toLowerCase());
};

const checkAll = (status) => {
  checkAllDevices.value = status;
  selectedDevicesData.value = status ? props.devices.map(device => device['deviceId']) : [];
};

const getDeviceName = (name) => name.length > 29 ? `${name.substring(0, 29)}...` : name;

watch(devicesSearch, () => {
  checkAllDevices.value = selectedDevicesData.value.length === props.devices.length;
});

watch(selectedDevicesData, () => {
  checkAllDevices.value = selectedDevicesData.value.length === props.devices.length;
  emit('update:modelValue', selectedDevicesData.value);
}, { deep: true });

function clearSearch() {
  devicesSearch.value = '';
  checkAllDevices.value = valueProps.value.length === props.devices.length;
}

</script>

<style scoped lang="scss">
.scroll {
  overflow-y: auto;
  max-height: 400px;
}
</style>
